import React from 'react';
import {useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import Input from "../../../../common/Input";
import {setEditClient} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import {setSaveEditClient} from "../../../../../_reducers/activitySlice";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";

const EditClientAccounting = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);
    const ACTIVITY = useSelector((state) => state.ACTIVITY);

    const handleOnChange = (e, type, compName) => {
        if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
        if(type === "input") {
            if(compName === "accounting") {
                dispatch(setEditClient({...editClient, accounting: e.target.value}));
            } else if (compName === "bypassAccounting") {
                dispatch(setEditClient({...editClient, bypassAccounting: e.target.value}));
            }
        }
    }

    return(
        <React.Fragment>
            <Row>
                <Col md={4}>
                    <Input
                        name="accounting"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                        label="Πρόθεμα Κωδικού Λογαριασμού"
                        value={editClient.accounting}
                        onChange={(e) => handleOnChange(e, "input", "accounting")}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name="bypassAccounting"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης"
                        label="Κωδικός Λογαριασμού Παράκαμψης"
                        value={editClient.bypassAccounting}
                        onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default EditClientAccounting;
